import { LayerDefinition } from './types';

export const darkskiesDefinition: LayerDefinition = {
  id: 'darkskies',
  name: 'Dark Skies & Astrophotography',
  category: 'forecast',
  categoryLabel: 'Forecast Quality Scoring',
  icon: '✨',
  description: 'Shows a forecast for night sky clarity. This map uses numerous environmental, atmospheric and lunar/solar inputs to show an hourly forecast of night sky viewing conditions. Bortle score is already an input, so no need to cross reference Bortle.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf', 'World Atlas Light Pollution'],
  outputModels: ['blend', 'hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf'],
  config: {
    defaultModel: 'blend',
    defaultOpacity: 0.8
  }
};

export default darkskiesDefinition;
